/** angular */
import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BydDialogDataInterface } from '../../../shared/interfaces/byd-dialog-data.interface';
/** end angular */

@Component({
  selector: 'byd-confirm-dialog',
  templateUrl: './byd-confirm-dialog.component.html',
  styleUrls: ['./byd-confirm-dialog.component.scss'],
})
export class BydConfirmDialogComponent {
  /**
   *
   */
  public data: BydDialogDataInterface;

  /**
   * Creates an instance of DsPromptDialogComponent.
   *
   * @param dialogRef reference to a dialog opened via the MatDialog service
   * @param data DialogDataInterface
   */
  constructor(
    private dialogRef: MatDialogRef<BydConfirmDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data: BydDialogDataInterface
  ) {
    if (!data) {
      return;
    }
    this.data = data;
    if (!this.data.validate) {
      this.data.validate = 'globals.validate';
    }
    if (!this.data.cancel) {
      this.data.cancel = 'globals.cancel';
    }
  }

  /**
   * Close the dialog opened via the MatDialog service.
   */
  close() {
    this.dialogRef.close(false);
  }

  /**
   * Close the dialog with `true` as dialogResult.
   */
  validate() {
    this.dialogRef.close(true);
  }
}
